<button
  tabindex="0"
  id="image-list-canva-button"
  class="btn btn-default btn-block"
  (click)="designWithCanva()"
  (keyup.enter)="designWithCanva()"
  [disabled]="disabled"
  aria-label="Design with Canva"
>
  <strong>Design with Canva</strong>
</button>
